import useMonetizacion from "@/features/monetizacion/hooks/use-monetizacion";
import { getTransferenciaItem, getTransferenciaMetodoMonedaCantidad, isMontoActive } from "@/features/monetizacion/shared/utils";
import { CajaApertura } from "@/shared/types/caja-apertura";
import { Moneda } from "@/shared/types/moneda";
import { TransferenciaMetodo } from "@/shared/types/transferencia-metodo";
import { useMemo } from "react";

export default function useGetCajaAperturaMetodosMonedas(cajaApertura: CajaApertura, complete: boolean = false): [TransferenciaMetodo[], Record<string, Moneda[]>, Moneda[]] {
    const monetizacion = useMonetizacion();

    //No es tan optimo como implemente esto, pero tampoco importa tanto
    return useMemo(() => {
        //Crear una lista de transferencia metodos que se encuentra en transferencia inicial o transferencia total
        //Si complete = true, la lista debe tambien contener los metodos no ocultos
        const transferenciaMetodos = monetizacion.transferenciaMetodos.filter(tm => {
            if (complete && !tm.hidden) return true;
            const tii = getTransferenciaItem(cajaApertura.transferenciaInicial, tm.id);
            const tti = getTransferenciaItem(cajaApertura.transferenciaTotal, tm.id);
            return isMontoActive(tii.monto) || isMontoActive(tti.monto);
        })

        //Crear un mapa de metodo:moneda[]
        //Si complete = true, la lista debe tambien contener las monedas no oculta
        const metodoMonedasMap = transferenciaMetodos.reduce((prev, curr) => {
            prev[curr.id] = monetizacion.monedas.filter(m => {
                if (complete && !m.hidden) return true;
                const tiic = getTransferenciaMetodoMonedaCantidad(cajaApertura.transferenciaInicial, curr.id, m.id);
                const ttic = getTransferenciaMetodoMonedaCantidad(cajaApertura.transferenciaTotal, curr.id, m.id);
                return tiic !== 0 || ttic !== 0;
            })
            return prev;
        }, {} as Record<string, Moneda[]>)


        //Lista de monedas, que es el mapa de metodo:moneda[] aplanado
        //Si complete = true, la lista debe tambien contener las monedas no ocultas
        const monedas = monetizacion.monedas.filter(m => {
            if (complete && !m.hidden) return true;
            for (const tm of transferenciaMetodos) {
                const tiic = getTransferenciaMetodoMonedaCantidad(cajaApertura.transferenciaInicial, tm.id, m.id);
                const ttic = getTransferenciaMetodoMonedaCantidad(cajaApertura.transferenciaTotal, tm.id, m.id);
                if (tiic !== 0 || ttic !== 0) return true;
            }
            return false;
        });

        return [transferenciaMetodos, metodoMonedasMap, monedas];
    }, [cajaApertura]);
}